import MalnutritionAPIContext from ".";
import {
  useMalnutritionRiskQuery,
  usePatientWeightsQuery,
} from "../../api/malnutrition-queries";

import type { FC, ReactNode } from "react";

interface MalnutritionAPIContextProviderProps {
  emrPatientID: string;
  children?: ReactNode;
}

const MalnutritionAPIContextProvider: FC<MalnutritionAPIContextProviderProps> = ({
  emrPatientID,
  children,
}) => {
  const riskAssessmentQuery = useMalnutritionRiskQuery(emrPatientID);
  const weightsQuery = usePatientWeightsQuery(emrPatientID);

  return (
    <MalnutritionAPIContext.Provider
      value={{
        emrPatientID,
        riskAssessmentQuery,
        weightsQuery,
      }}
    >
      {children}
    </MalnutritionAPIContext.Provider>
  );
};

export default MalnutritionAPIContextProvider;
